<template>

    <div class="header">
			<div class="logo">
				 <span><a   class="nav-link" @click="gethome()"><img :src="logo" alt="速购快递"></a></span>
				
			</div>
			<ul class="nav">
				<li>
					<router-link to="/member">会员首页</router-link>
				</li>
				<!-- <li>
					<a href="javascript:;">訂單列表</a>
					<i class="iconfont iconjiantou-copy"></i>
					<ul class="subnav">
						<li>
							<div class="triangle"></div>
						</li>
						<li>
							<a href="javascript:;">我的訂單</a>
						</li>
						<li>
							<a href="javascript:;">我的訂單</a>
						</li>
					</ul>
				</li> -->
				<li>
					<router-link to="/wallet">我的錢包</router-link>
					<!-- <i class="iconfont iconjiantou-copy"></i> -->
				</li>
				<!-- <li>
					<a href="javascript:;">我的客服</a>
				</li> -->
				<li v-if="jurisdiction=='true'">
					<router-link to="/storereport">下载报表</router-link>
				</li>
				<li>
					<router-link to="/indent">我的訂單</router-link>
				</li>
				<li v-if="false">
					<router-link to="/Guest">我的客服</router-link>
				</li>
				<li @click="signout()">
					<a href="javascript:;">退出登錄</a>
				</li>
			</ul>
			<div class="user">
				<i class="iconfont iconyonghu"></i>
				<span>用户，你好</span>
				<i class="iconfont iconsanjiaoxing"></i>
			</div>
		</div>

</template>
<style src="@/assets/font/iconfont.css"  scoped></style>
<style src="@/assets/css/master.css"  scoped></style>
<style src="@/assets/css/base.css"  scoped></style>
<style src="@/assets/css/style.css"  scoped></style>
<script> 
import "@/assets/font/iconfont.js"

export default{
    name:'App',
    data(){
        var logo = require("@/images/logo.png")
        return{
            logo:logo,
			jurisdiction:false,
        }
    },
	created(){
		this.jurisdiction=localStorage.getItem("jurisdiction")
	},
    methods: {
		jump(){
			alert('開發中')
		},
		skip(){
			this.$router.push({ //this 全局调用 查找router方法
				path:'/indent'
			})
		},
		signout(){
			localStorage.clear(); 
			window.location.href = "http://www.sugouex.com/";
		},
		gethome(){ 
			// localStorage.clear(); 
			window.location.href = "http://www.sugouex.com/";
		},
	},
	watch:{
		$route(to,from){
			// console.log(to,'这是',from);
			// console.log(to.path);
		}
	},
	beforeCreate() {
			document.querySelector('body').setAttribute('class', 'bodybackground')
	},
    
}
// $("#app").css('background','../images/bgimg.jpg');
// $("#app").addClass("selected");
</script>


<style>
	.nav{
		padding-left: 100px !important;
	}
	.nav li{
		width: 72px !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/common/user_header.vue